import { format } from 'date-fns';

export const formatWithoutTZ = (date: Date) => {
  return format(date, "yyyy-MM-dd'T'HH:mm:ss");
};
